import React from 'react';
import './EventModal.css'; // Reuse the same styling as EventModal

const EventDetailsModal = ({ isOpen, onClose, onEdit, event }) => {
  if (!isOpen || !event) return null;
  
  // Format the event time
  const formatTime = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString();
  };
  
  const startDate = formatDate(event.start);
  const startTime = formatTime(event.start);
  const endDate = formatDate(event.end);
  const endTime = formatTime(event.end);
  
  // Extract properties with fallbacks
  const { title, extendedProps } = event;
  const description = extendedProps?.description || '';
  const location = extendedProps?.location || '';
  const creatorName = extendedProps?.creatorName || 
                     extendedProps?.creator || 
                     extendedProps?.createdBy || 
                     'Band Member';
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <div className="event-details">
          {description && (
            <div className="detail-group">
              <h3>Description</h3>
              <p>{description}</p>
            </div>
          )}
          
          {location && (
            <div className="detail-group">
              <h3>Location</h3>
              <p>{location}</p>
            </div>
          )}
          
          <div className="detail-group">
            <h3>Date & Time</h3>
            <p>
              {startDate === endDate ? (
                <>
                  {startDate} from {startTime} to {endTime}
                </>
              ) : (
                <>
                  From {startDate} {startTime} to {endDate} {endTime}
                </>
              )}
            </p>
          </div>
          
          <div className="detail-group">
            <h3>Created By</h3>
            <p>{creatorName}</p>
          </div>
        </div>
        
        <div className="modal-footer">
          <div className="modal-footer-right">
            <button type="button" className="cancel-button" onClick={onClose}>Close</button>
            <button type="button" className="save-button" onClick={onEdit}>Edit Event</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetailsModal;
